import { supabase } from "./client";

export const supabaseFunctionsProvider = {
  /**
   * Invoca una Edge Function de Supabase de manera agnóstica.
   * @param {string} functionName - Nombre de la función a invocar.
   * @param {object} options - Opciones de la petición (cuerpo, cabeceras, etc.).
   */
  invoke: async (functionName, options = {}) => {
    return await supabase.functions.invoke(functionName, options);
  },
};
